/* eslint-disable no-undef */
export const pushEcommerceImpressions = (hits, list) => {
	if (dataLayer !== null && hits && hits.length > 0) {
		dataLayer.push({
			ecommerce: {
				impressions: hits.map((hit, index) => ({
					id: hit.objectID,
					name: hit.ProductName,
					list: list,
					position: index + 1,
				})),
			},
		});
	}
};
